import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { _HealthIDType, _StructureCatalog } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { HealthIDStructureItem } from "./HealthIDStructureItem/HealthIDStructureItem";


export const HealthIDStructure = () => {

    const Structure = useDataBean(_StructureCatalog);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalitems, setModalitems] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        Structure.instance.getHealthIDStructureCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        Structure.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        Structure.deleteItemVoid(Structure.bean.IDHealthIDStructure).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        Structure.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDHealthIDStructure', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Formato Genérico del Código', property: 'CodeFormat', visible: true },
        { title: 'Separador de Código', property: 'CodeSeparator', visible: true },
        { title: 'País', property: 'Country', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${Structure.bean.Name}`, "view": true }) } },
            { titulo: 'Items del código', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalitems({ ...modalitems, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Estructura de Códigos de Salud">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={Structure.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={Structure.bean.Name} onChange={Structure.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Formato Genérico del Código</label>
                                <input type="text" name="CodeFormat" className="form-control" value={Structure.bean.CodeFormat} onChange={Structure.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Separador del Código</label>
                                <input type="text" name="CodeSeparator" className="form-control" value={Structure.bean.CodeSeparator} onChange={Structure.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>País</label>
                                <input type="text" name="Country" className="form-control" value={Structure.bean.Country} onChange={Structure.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={Structure.bean.Description} onChange={Structure.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalitems} updateModal={setModalitems} >
                        <div className="row">
                            <HealthIDStructureItem idHealthIDStructure={Structure.bean.IDHealthIDStructure} />
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {Structure.bean.Name}</strong>
                    </ModalConfirm>
                </div>
            </div>
        </BasicPage>
    )
}